// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-DatePickers-styles___popover--W13Zy {
  box-shadow: none;
}

.components-DatePickers-styles___datePicker--wIaVu {
  width: 100%;
}

.components-DatePickers-styles___textField--e1ojf > div:focus-within .components-DatePickers-styles___close--eZAMq .components-DatePickers-styles___icon--EY58B, .components-DatePickers-styles___textField--e1ojf > div:focus .components-DatePickers-styles___close--eZAMq .components-DatePickers-styles___icon--EY58B, .components-DatePickers-styles___textField--e1ojf > div:active .components-DatePickers-styles___close--eZAMq .components-DatePickers-styles___icon--EY58B {
        color: rgba(0, 0, 0, 0.23) !important;
      }

.components-DatePickers-styles___close--eZAMq {
  padding: 2px;
}

.components-DatePickers-styles___close--eZAMq .components-DatePickers-styles___icon--EY58B {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.23);
    font-size: 16px;
    z-index: 9999;
  }

.components-DatePickers-styles___close--eZAMq .components-DatePickers-styles___iconInvisible--JgVwL {
    color: transparent;
    font-size: 16px;
  }

.CalendarMonthGrid {
    top: 10px;
  }

.DayPicker {
    min-width: 328px;
  }

.DayPicker_transitionContainer {
    min-width: 327px;
  }

.DayPicker_focusRegion {
    min-width: 327px;
  }

.DayPicker_weekHeader {
    top: 72px;
  }

.CalendarDay_1 {
    background: transparent;
  }

.CalendarDay_1:hover, .CalendarDay_1:focus, .CalendarDay_1:active {
      background: transparent;
      border: none;
    }

.CalendarDay_1:focus {
      background: transparent;
      border: none;
    }

.CalendarDay_1 .dayPicker {
      border-radius: 16px;
      border: none !important;
    }

.CalendarDay_1:hover .dayPicker {
        background: #318afb;
        color: #fff;
      }

.CalendarDay__selected_span {
    background: transparent;
    border: none;
    color: white;
  }

.CalendarDay__selected_span .dayPicker {
      background: #318afb;
      color: white;
      border: none;
      margin: 4px 0;
      border-radius: 0 !important;
    }

.CalendarDay__selected_span:hover {
    background: transparent;
    border: none;
  }

.CalendarDay__selected_span:hover .dayPicker {
      background: #318afb;
      border: none;
      border-radius: 0;
    }

.CalendarDay__selected {
    background: transparent;
    border: none;
  }

.CalendarDay__selected .dayPicker {
      border-radius: 0;
      background: #318afb;
      color: white;
      border: none;
    }

.CalendarDay__selected:hover {
    background: transparent;
    border: none;
  }

.CalendarDay__selected:hover .dayPicker {
      background: #318afb;
      color: white;
      border: none;
      border-radius: 0;
    }

.CalendarDay__hovered_span:hover, .CalendarDay__hovered_span {
    background: transparent;
    border: none;
  }

.CalendarDay__hovered_span:hover .dayPicker, .CalendarDay__hovered_span .dayPicker {
      background: #318afb;
      color: white;
      border: none;
      border-radius: 0 !important;
      margin: 4px 0;
    }

.CalendarDay__hovered_span:hover .dayPicker, .CalendarDay__hovered_span:focus .dayPicker, .CalendarDay__hovered_span:active .dayPicker {
        border-top-left-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
        border-top-right-radius: 16px !important;
        border-bottom-right-radius: 16px !important;
      }

.CalendarDay__selected_start .dayPicker {
      margin: 0px;
      border-top-left-radius: 16px !important;
      border-bottom-left-radius: 16px !important;
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }

.CalendarDay__selected_end .dayPicker {
      margin: 0px;
      border-top-right-radius: 16px !important;
      border-bottom-right-radius: 16px !important;
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
    }

.CalendarDay__default {
    border: none;
    padding: 0;
  }

.CalendarMonth_caption {
    border-bottom: 1px solid #c6c8cc;
    padding-bottom: 50px;
  }

.CalendarMonth_caption strong {
      font-weight: 500;
    }

.CalendarMonth_table_1 {
    margin: 10px 0 0;
  }

.CalendarMonth_caption {
    font-size: 15px;
  }

.DayPickerNavigation .DayPickerNavigation_button {
      position: absolute;
      top: 29px;
    }

.DayPickerNavigation .DayPickerNavigation_button svg {
        width: 14px;
        outline: none;
      }

.DayPickerNavigation .DayPickerNavigation_button:first-child {
        left: 22px;
      }

.DayPickerNavigation .DayPickerNavigation_button:last-child {
        right: 22px;
      }

.singleDatePicker {
    position: relative;
    min-height: 308px;
  }

.singleDatePicker .CalendarDay__selected {
      border-radius: 50%;
    }

.dayPicker {
    margin: 4px;
    padding: 3px 7px;
    border-radius: 16px !important;
  }

.DayPicker__withBorder {
    box-shadow: none;
  }

.react-datepicker__day:not([aria-disabled='true']):hover, .react-datepicker__month-text:not([aria-disabled='true']):hover, .react-datepicker__quarter-text:not([aria-disabled='true']):hover, .react-datepicker__year-text:not([aria-disabled='true']):hover {
    background: #318afb;
    color: white !important;
    border-radius: 16px;
  }

.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
    background: #318afb;
    color: white !important;
  }

.react-datepicker__day--selected {
    background: #318afb;
    color: white !important;
  }

.react-datepicker {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  }

.react-datepicker-popper {
    max-width: 320px;
  }

.react-datepicker__aria-live, .react-datepicker__input-container, .react-datepicker__triangle {
    display: none !important;
  }

.react-datepicker__month {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 5px;
    color: rgb(117, 117, 117);
  }

.react-datepicker__day {
    width: 30px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.2sease;
    font-size: 14px;
    border-radius: 16px;
    padding-top: 3px;
    padding-bottom: 3px;
    margin-top: 2px;
    margin-bottom: 2px;
    color: rgb(72, 72, 72);
    font-weight: 400;
  }

.react-datepicker__day--outside-month {
    visibility: hidden;
  }

.react-datepicker__day:hover {
    background-color: #f0f0f0;
    color: #000;
  }

.react-datepicker {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
    border: none;
    padding-top: 0;
  }

.react-datepicker__week {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    font-weight: bold;
    color: #333;
  }

.react-datepicker__day-name {
    flex: 1;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
  }

.react-datepicker__day-names {
    display: flex;
    justify-content: space-evenly;
    border-bottom: 1px solid #c6c8cc;
    padding-bottom: 5px;
    margin-bottom: 5px;
    margin-left: 8px;
    margin-right: 8px;
    color: rgb(177, 177, 177);
  }

.react-datepicker__day:hover {
    background: #318afb;
    color: #fff;
  }

.react-datepicker__header--custom {
    background-color: white !important;
    border-bottom: none;
    padding: 0;
  }

.react-datepicker__header .custom-header {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white !important;
      border-radius: 5px;
      border-bottom: none;
      padding: 0;
    }

.react-datepicker__header .custom-nav-button {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 20px;
      color: #333;
      margin: 0 10px;
    }

.react-datepicker__header .custom-nav-button svg {
        font-size: 15px;
      }

.react-datepicker__header .react-datepicker__aria-live {
      display: none;
    }

.react-datepicker__header .custom-dropdown {
      padding: 5px;
      font-size: 16px;
      margin: 0 10px;
      border-radius: 5px;
      border: none;
    }

.react-datepicker__header .custom-dropdown:focus {
      outline: none;
      border-color: #007bff;
    }

.singleDatePicker {
    width: 320px;
  }

.components-DatePickers-styles___yearMonth--SHNVn {
  display: flex;
  justify-content: space-evenly;
}

.components-DatePickers-styles___formControl--kXNBg {
  margin: 0;
  min-width: 100px;
  height: 21px;
  align-items: center;
}

.components-DatePickers-styles___formControl--kXNBg .components-DatePickers-styles___select--Gz55W:before,
    .components-DatePickers-styles___formControl--kXNBg .components-DatePickers-styles___select--Gz55W:after {
      border: none !important;
    }

.components-DatePickers-styles___bottomText--kzJ5G {
  text-align: right;
  font-size: 15px;
  padding: 24px;
}
`, "",{"version":3,"sources":["webpack://./components/DatePickers/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAOM;QACE,qCAAqC;MACvC;;AAKN;EACE,YAAY;AAWd;;AAVE;IACE,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,aAAa;EACf;;AACA;IACE,kBAAkB;IAClB,eAAe;EACjB;;AAIA;IACE,SAAS;EACX;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,SAAS;EACX;;AAEA;IACE,uBAAuB;EAyBzB;;AAvBE;MAGE,uBAAuB;MACvB,YAAY;IACd;;AAEA;MACE,uBAAuB;MACvB,YAAY;IACd;;AAEA;MACE,mBAAmB;MACnB,uBAAuB;IACzB;;AAGE;QACE,mBAAmB;QACnB,WAAW;MACb;;AAIJ;IACE,uBAAuB;IACvB,YAAY;IACZ,YAAY;EASd;;AAPE;MACE,mBAAmB;MACnB,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,2BAA2B;IAC7B;;AAGF;IACE,uBAAuB;IACvB,YAAY;EAOd;;AALE;MACE,mBAAmB;MACnB,YAAY;MACZ,gBAAgB;IAClB;;AAGF;IACE,uBAAuB;IACvB,YAAY;EAQd;;AANE;MACE,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;MACZ,YAAY;IACd;;AAGF;IACE,uBAAuB;IACvB,YAAY;EAQd;;AANE;MACE,mBAAmB;MACnB,YAAY;MACZ,YAAY;MACZ,gBAAgB;IAClB;;AAGF;IAEE,uBAAuB;IACvB,YAAY;EASd;;AAPE;MACE,mBAAmB;MACnB,YAAY;MACZ,YAAY;MACZ,2BAA2B;MAC3B,aAAa;IACf;;AAOE;QACE,sCAAsC;QACtC,yCAAyC;QACzC,wCAAwC;QACxC,2CAA2C;MAC7C;;AAKF;MACE,WAAW;MACX,uCAAuC;MACvC,0CAA0C;MAC1C,uCAAuC;MACvC,0CAA0C;IAC5C;;AAIA;MACE,WAAW;MACX,wCAAwC;MACxC,2CAA2C;MAC3C,sCAAsC;MACtC,yCAAyC;IAC3C;;AAGF;IACE,YAAY;IACZ,UAAU;EACZ;;AAEA;IACE,gCAAgC;IAChC,oBAAoB;EAKtB;;AAHE;MACE,gBAAgB;IAClB;;AAGF;IACE,gBAAgB;EAClB;;AAEA;IACE,eAAe;EACjB;;AAGE;MACE,kBAAkB;MAClB,SAAS;IAcX;;AAZE;QACE,WAAW;QACX,aAAa;MACf;;AAEA;QACE,UAAU;MACZ;;AAEA;QACE,WAAW;MACb;;AAIJ;IACE,kBAAkB;IAClB,iBAAiB;EAKnB;;AAHE;MACE,kBAAkB;IACpB;;AAGF;IACE,WAAW;IACX,gBAAgB;IAChB,8BAA8B;EAChC;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IAIE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;AAEA;IAIE,mBAAmB;IACnB,uBAAuB;EACzB;;AAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;AACA;IACE,uDAAuD;EACzD;;AAEA;IACE,gBAAgB;EAClB;;AACA;IAGE,wBAAwB;EAC1B;;AAEA;IACE,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,QAAQ;IACR,yBAAyB;EAC3B;;AAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;EAClB;;AAEA;IACE,kBAAkB;EACpB;;AAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;AAEA;IACE,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,cAAc;EAChB;;AAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;IACjB,WAAW;EACb;;AAEA;IACE,OAAO;IACP,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;AAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;EAC3B;;AAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;AAEA;IACE,kCAAkC;IAClC,mBAAmB;IACnB,UAAU;EACZ;;AAGE;MACE,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,kCAAkC;MAClC,kBAAkB;MAClB,mBAAmB;MACnB,UAAU;IACZ;;AAEA;MACE,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,eAAe;MACf,WAAW;MACX,cAAc;IAKhB;;AAHE;QACE,eAAe;MACjB;;AAEF;MACE,aAAa;IACf;;AAEA;MACE,YAAY;MACZ,eAAe;MACf,cAAc;MACd,kBAAkB;MAClB,YAAY;IACd;;AAEA;MACE,aAAa;MACb,qBAAqB;IACvB;;AAEF;IACE,YAAY;EACd;;AAGF;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AAQrB;;AALI;;MAEE,uBAAuB;IACzB;;AAIJ;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf","sourcesContent":[".popover {\n  box-shadow: none;\n}\n\n.datePicker {\n  width: 100%;\n}\n\n.textField > div {\n  &:focus-within,\n  &:focus,\n  &:active {\n    .close {\n      .icon {\n        color: rgba(0, 0, 0, 0.23) !important;\n      }\n    }\n  }\n}\n\n.close {\n  padding: 2px;\n  .icon {\n    cursor: pointer;\n    color: rgba(0, 0, 0, 0.23);\n    font-size: 16px;\n    z-index: 9999;\n  }\n  .iconInvisible {\n    color: transparent;\n    font-size: 16px;\n  }\n}\n\n:global {\n  .CalendarMonthGrid {\n    top: 10px;\n  }\n\n  .DayPicker {\n    min-width: 328px;\n  }\n\n  .DayPicker_transitionContainer {\n    min-width: 327px;\n  }\n\n  .DayPicker_focusRegion {\n    min-width: 327px;\n  }\n\n  .DayPicker_weekHeader {\n    top: 72px;\n  }\n\n  .CalendarDay_1 {\n    background: transparent;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background: transparent;\n      border: none;\n    }\n\n    &:focus {\n      background: transparent;\n      border: none;\n    }\n\n    .dayPicker {\n      border-radius: 16px;\n      border: none !important;\n    }\n\n    &:hover {\n      .dayPicker {\n        background: #318afb;\n        color: #fff;\n      }\n    }\n  }\n\n  .CalendarDay__selected_span {\n    background: transparent;\n    border: none;\n    color: white;\n\n    .dayPicker {\n      background: #318afb;\n      color: white;\n      border: none;\n      margin: 4px 0;\n      border-radius: 0 !important;\n    }\n  }\n\n  .CalendarDay__selected_span:hover {\n    background: transparent;\n    border: none;\n\n    .dayPicker {\n      background: #318afb;\n      border: none;\n      border-radius: 0;\n    }\n  }\n\n  .CalendarDay__selected {\n    background: transparent;\n    border: none;\n\n    .dayPicker {\n      border-radius: 0;\n      background: #318afb;\n      color: white;\n      border: none;\n    }\n  }\n\n  .CalendarDay__selected:hover {\n    background: transparent;\n    border: none;\n\n    .dayPicker {\n      background: #318afb;\n      color: white;\n      border: none;\n      border-radius: 0;\n    }\n  }\n\n  .CalendarDay__hovered_span:hover,\n  .CalendarDay__hovered_span {\n    background: transparent;\n    border: none;\n\n    .dayPicker {\n      background: #318afb;\n      color: white;\n      border: none;\n      border-radius: 0 !important;\n      margin: 4px 0;\n    }\n  }\n\n  .CalendarDay__hovered_span {\n    &:hover,\n    &:focus,\n    &:active {\n      .dayPicker {\n        border-top-left-radius: 0px !important;\n        border-bottom-left-radius: 0px !important;\n        border-top-right-radius: 16px !important;\n        border-bottom-right-radius: 16px !important;\n      }\n    }\n  }\n\n  .CalendarDay__selected_start {\n    .dayPicker {\n      margin: 0px;\n      border-top-left-radius: 16px !important;\n      border-bottom-left-radius: 16px !important;\n      border-top-right-radius: 0px !important;\n      border-bottom-right-radius: 0px !important;\n    }\n  }\n\n  .CalendarDay__selected_end {\n    .dayPicker {\n      margin: 0px;\n      border-top-right-radius: 16px !important;\n      border-bottom-right-radius: 16px !important;\n      border-top-left-radius: 0px !important;\n      border-bottom-left-radius: 0px !important;\n    }\n  }\n\n  .CalendarDay__default {\n    border: none;\n    padding: 0;\n  }\n\n  .CalendarMonth_caption {\n    border-bottom: 1px solid #c6c8cc;\n    padding-bottom: 50px;\n\n    strong {\n      font-weight: 500;\n    }\n  }\n\n  .CalendarMonth_table_1 {\n    margin: 10px 0 0;\n  }\n\n  .CalendarMonth_caption {\n    font-size: 15px;\n  }\n\n  .DayPickerNavigation {\n    .DayPickerNavigation_button {\n      position: absolute;\n      top: 29px;\n\n      svg {\n        width: 14px;\n        outline: none;\n      }\n\n      &:first-child {\n        left: 22px;\n      }\n\n      &:last-child {\n        right: 22px;\n      }\n    }\n  }\n\n  .singleDatePicker {\n    position: relative;\n    min-height: 308px;\n\n    .CalendarDay__selected {\n      border-radius: 50%;\n    }\n  }\n\n  .dayPicker {\n    margin: 4px;\n    padding: 3px 7px;\n    border-radius: 16px !important;\n  }\n\n  .DayPicker__withBorder {\n    box-shadow: none;\n  }\n\n  .react-datepicker__day:not([aria-disabled='true']):hover,\n  .react-datepicker__month-text:not([aria-disabled='true']):hover,\n  .react-datepicker__quarter-text:not([aria-disabled='true']):hover,\n  .react-datepicker__year-text:not([aria-disabled='true']):hover {\n    background: #318afb;\n    color: white !important;\n    border-radius: 16px;\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected,\n  .react-datepicker__year-text--keyboard-selected {\n    background: #318afb;\n    color: white !important;\n  }\n\n  .react-datepicker__day--selected {\n    background: #318afb;\n    color: white !important;\n  }\n  .react-datepicker {\n    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  }\n\n  .react-datepicker-popper {\n    max-width: 320px;\n  }\n  .react-datepicker__aria-live,\n  .react-datepicker__input-container,\n  .react-datepicker__triangle {\n    display: none !important;\n  }\n\n  .react-datepicker__month {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    gap: 5px;\n    color: rgb(117, 117, 117);\n  }\n\n  .react-datepicker__day {\n    width: 30px;\n    height: 24px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: background-color 0.2sease;\n    font-size: 14px;\n    border-radius: 16px;\n    padding-top: 3px;\n    padding-bottom: 3px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n    color: rgb(72, 72, 72);\n    font-weight: 400;\n  }\n\n  .react-datepicker__day--outside-month {\n    visibility: hidden;\n  }\n\n  .react-datepicker__day:hover {\n    background-color: #f0f0f0;\n    color: #000;\n  }\n\n  .react-datepicker {\n    width: 100%;\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 10px;\n    border: none;\n    padding-top: 0;\n  }\n\n  .react-datepicker__week {\n    display: flex;\n    justify-content: space-evenly;\n    width: 100%;\n    font-weight: bold;\n    color: #333;\n  }\n\n  .react-datepicker__day-name {\n    flex: 1;\n    text-align: center;\n    padding: 5px 0;\n    font-size: 14px;\n  }\n\n  .react-datepicker__day-names {\n    display: flex;\n    justify-content: space-evenly;\n    border-bottom: 1px solid #c6c8cc;\n    padding-bottom: 5px;\n    margin-bottom: 5px;\n    margin-left: 8px;\n    margin-right: 8px;\n    color: rgb(177, 177, 177);\n  }\n\n  .react-datepicker__day:hover {\n    background: #318afb;\n    color: #fff;\n  }\n\n  .react-datepicker__header--custom {\n    background-color: white !important;\n    border-bottom: none;\n    padding: 0;\n  }\n\n  .react-datepicker__header {\n    .custom-header {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: white !important;\n      border-radius: 5px;\n      border-bottom: none;\n      padding: 0;\n    }\n\n    .custom-nav-button {\n      background: none;\n      border: none;\n      cursor: pointer;\n      font-size: 20px;\n      color: #333;\n      margin: 0 10px;\n\n      svg {\n        font-size: 15px;\n      }\n    }\n    .react-datepicker__aria-live {\n      display: none;\n    }\n\n    .custom-dropdown {\n      padding: 5px;\n      font-size: 16px;\n      margin: 0 10px;\n      border-radius: 5px;\n      border: none;\n    }\n\n    .custom-dropdown:focus {\n      outline: none;\n      border-color: #007bff;\n    }\n  }\n  .singleDatePicker {\n    width: 320px;\n  }\n}\n\n.yearMonth {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.formControl {\n  margin: 0;\n  min-width: 100px;\n  height: 21px;\n  align-items: center;\n\n  .select {\n    &:before,\n    &:after {\n      border: none !important;\n    }\n  }\n}\n\n.bottomText {\n  text-align: right;\n  font-size: 15px;\n  padding: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `components-DatePickers-styles___popover--W13Zy`,
	"datePicker": `components-DatePickers-styles___datePicker--wIaVu`,
	"textField": `components-DatePickers-styles___textField--e1ojf`,
	"close": `components-DatePickers-styles___close--eZAMq`,
	"icon": `components-DatePickers-styles___icon--EY58B`,
	"iconInvisible": `components-DatePickers-styles___iconInvisible--JgVwL`,
	"yearMonth": `components-DatePickers-styles___yearMonth--SHNVn`,
	"formControl": `components-DatePickers-styles___formControl--kXNBg`,
	"select": `components-DatePickers-styles___select--Gz55W`,
	"bottomText": `components-DatePickers-styles___bottomText--kzJ5G`
};
module.exports = ___CSS_LOADER_EXPORT___;
